var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g(_vm._b({directives:[{name:"mask",rawName:"v-mask",value:(_vm.mask),expression:"mask"}],staticClass:"mb-5",staticStyle:{"background-color":"white"},attrs:{"rounded":_vm.rounded,"outlined":_vm.outlined,"hide-details":"","dense":!_vm.$_isMobile},on:{"change":_vm.$_swap}},'v-text-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }